<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off">
                            <input type="text" placeholder="search" (keyup.enter)="getAppPropertiesConfigByWildSearch()"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getAppPropertiesConfigByWildSearch()"></i>
                    </div>
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i
                            class="bi bi-plus-lg"></i> {{ 'generic.add' | translate
                        }}</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 20%;">Client ID</th>
                        <th style="width: 30%;">Key</th>
                        <th style="width: 30%;">Value</th>
                        <th style="width: 20%;">Description</th>
                        <!-- <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th> -->
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" id="{{data.id}}" [ngClass]="{ 'delete-highlight': data.id == recordId }" *ngFor="let data of appPropertiesConfigList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 20%;">{{data.clientId || " -- " }}</p>
                    <p style="width: 30%;">{{data.key || " -- " }}</p>
                    <p style="width: 30%;">{{data.value || " -- " }}</p>
                    <p style="width: 20%;">{{data.description || " -- " }}</p>

                    <!-- <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i data-toggle="modal" title="View"
                            (click)="viewAppPropertiesConfigById(data.id)"
                            data-target="#viewModal" class="bi bi-eye-fill"></i>
                        <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square"
                            (click)="getAppPropertiesConfigById(data.id)" data-toggle="modal"
                            data-target="#editModal"></i>
                        <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                            (click)="deleteIdSelect(data.id,data)" data-toggle="modal"
                            data-target="#deleteModal"></i>
                    </p> -->
                </div>
            </div>


            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && appPropertiesConfigList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>

            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>


        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteAppPropertiesConfig()" class="btn btn-primary">{{
                        'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add App Properties Config
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="appPropertiesConfigForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Client ID <span class="required">*</span></label>
                                <input formControlName="clientId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="appPropertiesConfigForm.get('clientId')?.invalid && formSubmit">Client ID
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Key <span class="required">*</span></label>
                                <input formControlName="key" type="text" class="form-control">
                                <span class="err" *ngIf="appPropertiesConfigForm.get('key')?.invalid && formSubmit">Key
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Value <span class="required">*</span></label>
                                <input formControlName="value" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="appPropertiesConfigForm.get('value')?.invalid && formSubmit">Value
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>QR Code Image Link</label>
                                <input formControlName="qrCodeImageLink" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Description <span class="required">*</span></label>
                                <textarea formControlName="description" class="form-control"></textarea>
                                <span class="err"
                                    *ngIf="appPropertiesConfigForm.get('description')?.invalid && formSubmit">Description
                                    required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>

                    <button type="button" (click)="addAppPropertiesConfig()" class="btn btn-primary">{{ 'generic.add' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit App Properties Config
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="appPropertiesConfigUpdateForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Client ID <span class="required">*</span></label>
                                <input formControlName="clientId" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="appPropertiesConfigUpdateForm.get('clientId')?.invalid && formSubmit">Client
                                    ID required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Key <span class="required">*</span></label>
                                <input formControlName="key" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="appPropertiesConfigUpdateForm.get('key')?.invalid && formSubmit">Key
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Value <span class="required">*</span></label>
                                <input formControlName="value" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="appPropertiesConfigUpdateForm.get('value')?.invalid && formSubmit">Value
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>QR Code Image Link</label>
                                <input formControlName="qrCodeImageLink" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Description <span class="required">*</span></label>
                                <textarea formControlName="description" class="form-control"></textarea>
                                <span class="err"
                                    *ngIf="appPropertiesConfigUpdateForm.get('description')?.invalid && formSubmit">Description
                                    required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalButton3" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateAppPropertiesConfig()" class="btn btn-primary">{{
                        'generic.update' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewModalLabel">View App Properties Config
                    <span class="header-action" data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="service-data" *ngFor="let viewData of singleData">
                    <div class="form-group">
                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-6 col-lg-6">
                                <label>Client ID :</label>
                                <p>{{viewData.clientId || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Key :</label>
                                <p>{{viewData.key || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Value :</label>
                                <p>{{viewData.value || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>QR Code Image Link :</label>
                                <p>{{viewData.qrCodeImageLink || '--'}}</p>
                            </div>
                            <div class="col-md-12 col-lg-12 mt-2">
                                <label>Description :</label>
                                <p>{{viewData.description || '--'}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closePopUp()">{{
                    'generic.close' | translate }}</button>
            </div>
        </div>
    </div>
</div>